import useSWR from 'swr';
import { RefereeStatsItemFragment } from '@amf/shared/types/graphql';
import { useMemo } from 'react';

const PATH = '/api/referee/stats';
const getKey = (referee: string) => () => {
  const params = new URLSearchParams({ referee });
  return `${PATH}?${params.toString()}`;
};

function useRefereeStats(id: string) {
  const { data, error } = useSWR<RefereeStatsItemFragment[]>(getKey(id));
  const stats = useMemo(() => (data && Array.isArray(data) ? data : []), [data]);
  const summary = useMemo<RefereeStatsItemFragment>(() => {
    if (!stats || stats.length === 0) return null;
    return {
      id: 'summary',
      leagueName: null,
      season: null,
      teams: [],
      matches: stats.map(s => s.matches).reduce((p, c) => p + c),
      matchesAsMain: stats.map(s => s.matchesAsMain).reduce((p, c) => p + c),
      matchesAsAssist: stats.map(s => s.matchesAsAssist).reduce((p, c) => p + c),
      redCards: stats.map(s => s.redCards).reduce((p, c) => p + c),
      yellowCards: stats.map(s => s.yellowCards).reduce((p, c) => p + c),
    };
  }, [stats]);

  return {
    error,
    stats,
    summary,
    loading: !data && !error,
  };
}

export default useRefereeStats;
